@if (mode === 'date') {
  <div class="input-group" [class.input-group-sm]="size === 'sm'">
    <input
      class="form-control"
      [class.form-control-sm]="size === 'sm'"
      [id]="inputId"
      [placeholder]="placeholder"
      [formControl]="$any(control)"
      [readonly]="readonly"
      ngbDatepicker
      #datePicker="ngbDatepicker"
    >
    <button
      class="btn btn-outline-secondary"
      [class.btn-sm]="size === 'sm'"
      type="button"
      (click)="datePicker.toggle()"
      [disabled]="(control?.disabled ?? false) || readonly"
      [title]="openCalendarLabel"
      [attr.aria-label]="openCalendarLabel"
    >
      <i class="bi bi-calendar"></i>
    </button>
  </div>
} @else {
  <input
    type="datetime-local"
    class="form-control"
    [class.form-control-sm]="size === 'sm'"
    [id]="inputId"
    [placeholder]="placeholder"
    [formControl]="$any(control)"
    [readonly]="readonly"
  >
}
